import React from "react";
import { ModalProps } from "../../interfaces/modal";
import { useSocialStore } from "../../stores/social";
import { Input } from "../ui/inputs/Input";
import { createEmployee } from "../../api/social";
import { showToastError, showToastSuccess } from "../../services/toast";
import { useTranslation } from "react-i18next";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const CreateEmployee: React.FC<ModalProps> = ({ closeModal }) => {
  const { formData, setFormData, updateSocial, setUpdateSocial, idCustomer } =
    useSocialStore();

  const { t } = useTranslation();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    createEmployee(Number(idCustomer), formData)
      .then(() => {
        showToastSuccess("Salarié créé avec succès");
        setFormData({});
        setUpdateSocial(!updateSocial);
        closeModal();
      })
      .catch(() => {
        showToastError("Une erreur est survenue.");
      });
  };

  return (
    <ModalShell
      title={t("Création d'un salarié")}
      size="md"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            {t("Annuler")}
          </ModalButton>
          <ModalButton variant="primary" type="submit" onClick={handleSubmit}>
            {t("Créer")}
          </ModalButton>
        </>
      }
    >
      <div className="grid grid-cols-1 gap-3 font-Nunito sm:grid-cols-3">
        <Input
          label={t("Prénom")}
          name="firstName"
          required={true}
          value={formData.firstName || ""}
          onChange={handleChange}
          clasName="w-full"
        />
        <Input
          label={t("Nom")}
          name="lastName"
          required={true}
          value={formData.lastName || ""}
          onChange={handleChange}
          clasName="w-full"
        />
        <Input
          label={t("Matricule")}
          name="matricule"
          required={true}
          value={formData.matricule || ""}
          onChange={handleChange}
          clasName="w-full"
        />
      </div>
    </ModalShell>
  );
};

export default CreateEmployee;
